import React, { useState } from "react";
import { TextField } from "@mui/material";

interface TwilioIntegrationFormProps {
  data?: any;
  onChange: (data: any) => void;
  onValidationChange?: (isValid: boolean) => void;
}

const TwilioIntegrationForm: React.FC<TwilioIntegrationFormProps> = ({
  data = {},
  onChange,
  onValidationChange,
}) => {
  const [formData, setFormData] = useState({
    accountSid: data.accountSid || "",
    authToken: data.authToken || "",
  });

  React.useEffect(() => {
    const isValid = 
      formData.accountSid.length > 0 &&
      formData.authToken.length > 0;
    
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [formData, onValidationChange]);

  const handleChange = (field: string, value: string) => {
    const newData = { ...formData, [field]: value };
    setFormData(newData);
    onChange(newData);
  };

  return (
    <>
      <TextField
        fullWidth
        margin="normal"
        label="Account SID"
        value={formData.accountSid}
        onChange={(e) => handleChange("accountSid", e.target.value)}
        placeholder="Your Twilio Account SID"
        required
      />
      <TextField
        fullWidth
        margin="normal"
        label="Auth Token"
        type="password"
        value={formData.authToken}
        onChange={(e) => handleChange("authToken", e.target.value)}
        placeholder="Your Twilio Auth Token"
        required
      />
    </>
  );
};

export default TwilioIntegrationForm;